import React from 'react';
import classnames from 'classnames';
import { Tooltip } from 'swag-client-common/components/info/tooltip';
import { Placement } from 'swag-client-common/constants';
import { HeaderIconsOther } from 'swag-client-common/components/partials/header-icons/header-icons-other';
import { NoInternationalShippingIcon } from 'swag-client-common/components/icons/no-international-shipping-icon';
import { FORBIDDEN_FOR_INVENTORY_TOOLTIP, FORBIDDEN_FOR_INVENTORY_IMG_ALT, SUPER_SPEED_TOOLTIP, SUPER_SPEED_IMG_ALT, NO_INTERATIONAL_SHIPPING_TOOLTIP, NO_INTERATIONAL_SHIPPING_IMG_ALT } from './header-icons-constants';
import CSSclasses from './header-icons.scss';
import { NoInventory, SuperSpeed } from './icons';
export const popperProps = {
  modifiers: {
    offset: {
      enabled: true,
      offset: '0 15px'
    }
  }
};
export const tooltipClasses = {
  tooltip: CSSclasses.tooltip
};
export const HeaderIcons = ({
  isForbiddenForInventory,
  acceptableForBox,
  isLimitedEdition,
  isForbiddenToShipInternationally,
  showSuperSpeedIcon,
  className
}) => /*#__PURE__*/React.createElement("div", {
  className: classnames(CSSclasses.container, className)
}, /*#__PURE__*/React.createElement(HeaderIconsOther, {
  acceptableForBox: acceptableForBox,
  isLimitedEdition: isLimitedEdition
}), isForbiddenForInventory && /*#__PURE__*/React.createElement(Tooltip, {
  title: FORBIDDEN_FOR_INVENTORY_TOOLTIP,
  mode: "light",
  placement: Placement.RIGHT,
  classes: tooltipClasses,
  PopperProps: popperProps
}, /*#__PURE__*/React.createElement("div", {
  "aria-label": FORBIDDEN_FOR_INVENTORY_IMG_ALT,
  className: CSSclasses.icon
}, /*#__PURE__*/React.createElement(NoInventory, null))), showSuperSpeedIcon && /*#__PURE__*/React.createElement(Tooltip, {
  title: SUPER_SPEED_TOOLTIP,
  mode: "light",
  placement: Placement.RIGHT,
  classes: tooltipClasses,
  PopperProps: popperProps
}, /*#__PURE__*/React.createElement("div", {
  "aria-label": SUPER_SPEED_IMG_ALT,
  className: CSSclasses.icon
}, /*#__PURE__*/React.createElement(SuperSpeed, null))), isForbiddenToShipInternationally && /*#__PURE__*/React.createElement(Tooltip, {
  title: NO_INTERATIONAL_SHIPPING_TOOLTIP,
  mode: "light",
  placement: Placement.RIGHT,
  classes: tooltipClasses,
  PopperProps: popperProps
}, /*#__PURE__*/React.createElement("div", {
  "aria-label": NO_INTERATIONAL_SHIPPING_IMG_ALT,
  className: CSSclasses.icon
}, /*#__PURE__*/React.createElement(NoInternationalShippingIcon, null))));